import {
  getDatabase,
  off,
  ref,
  onValue,
  child,
  push,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  get,
  query as dbQuery,
  orderByKey,
  startAt,
  endAt,
  orderByValue,
  orderByChild,
  equalTo,
} from "firebase/database";
import Vue from "vue";
export default {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    async listenerBNKLineas({ commit, rootGetters }) {
      let last = await Vue.prototype.$dbHandler.getLastRecord(
        "BNK_LineasCredito",
        "upat"
      );
      const firestore = rootGetters.getFirebaseApp.firestore;
      const collection = firestore.collection("BNK_LineasCredito");
      const query = firestore.query(
        collection,
        firestore.where("upat", ">=", last ? last.value.upat : 0),
        firestore.where("Tenant", "==", rootGetters.getFirebaseApp.tenant)
      );

      const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "BNK_LineasCredito",
                element,
              },
              { root: true }
            );
          } else if (change.type === "modified") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "BNK_LineasCredito",
                element,
              },
              { root: true }
            );
          } else if (change.type === "removed") {
            commit(
              "dataLists/unsetArrayItem",
              {
                id: change.doc.id,
                list: "BNK_LineasCredito",
              },
              { root: true }
            );
          }
        });
      });
    },
    async listenerRVATarifas({ commit, rootGetters }) {
      if (!Vue.prototype.$dbHandler.getInstance()) {
        let store = Vue.prototype.$dbHandler
          .getInstance()
          .transaction(["RVA_Tarifas"], "readwrite")
          .objectStore("RVA_Tarifas");
        let data = store.index("id");
        let pdestroy = data.openKeyCursor();
        pdestroy.onsuccess = function () {
          let cursor = pdestroy.result;
          if (cursor) {
            store.delete(cursor.primaryKey);
            cursor.continue();
          }
        };
      }
      //let last = await Vue.prototype.$dbHandler.getLastRecord("BNK_LineasCredito","upat");
      const firestore = rootGetters.getFirebaseApp.firestore;
      const collection = firestore.collection("RVA_Tarifas");
      const query = firestore.query(
        collection,
        //firestore.where("upat", ">=", ((last)?last.value.upat:0)),
        firestore.where("Tenant", "==", rootGetters.getFirebaseApp.tenant)
      );

      const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "RVA_Tarifas",
                element,
              },
              { root: true }
            );
          } else if (change.type === "modified") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "RVA_Tarifas",
                element,
              },
              { root: true }
            );
          } else if (change.type === "removed") {
            commit(
              "dataLists/unsetArrayItem",
              {
                id: change.doc.id,
                list: "RVA_Tarifas",
              },
              { root: true }
            );
          }
        });
      });
    },
    async listenerMBSPlanes({ commit, rootGetters }) {
      const database = rootGetters.getFirebaseApp.database;
      const refe = ref(database, "MBS/Planes");
      onChildAdded(refe, (snapshot) => {
        const element = snapshot.val();
        element.Tenant = rootGetters.getFirebaseApp.tenant;
        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Planes",
            element,
          },
          { root: true }
        );
      });

      onChildChanged(refe, (snapshot) => {
        const element = snapshot.val();

        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Planes",
            element,
          },
          { root: true }
        );
      });

      onChildRemoved(refe, (snapshot) => {
        commit(
          "dataLists/unsetArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Planes",
          },
          { root: true }
        );
      });
    },
    async listenerMBSPeriodos({ commit, rootGetters }) {
      const database = rootGetters.getFirebaseApp.database;
      const refe = ref(database, "MBS/Periodos");
      onChildAdded(refe, (snapshot) => {
        const element = snapshot.val();
        element.Tenant = rootGetters.getFirebaseApp.tenant;
        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Periodos",
            element,
          },
          { root: true }
        );
      });

      onChildChanged(refe, (snapshot) => {
        const element = snapshot.val();

        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Periodos",
            element,
          },
          { root: true }
        );
      });

      onChildRemoved(refe, (snapshot) => {
        commit(
          "dataLists/unsetArrayItem",
          {
            id: snapshot.key,
            list: "MBS_Periodos",
          },
          { root: true }
        );
      });
    },
    async listenerMBSBeneficios({ commit, rootGetters }) {
      const firestore = rootGetters.getFirebaseApp.firestore;
      const collection = firestore.collection("MBS_Beneficios");
      const query = firestore.query(
        collection,
        firestore.where("Tenant", "==", rootGetters.getFirebaseApp.tenant)
      );

      const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "MBS_Beneficios",
                element,
              },
              { root: true }
            );
          } else if (change.type === "modified") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "MBS_Beneficios",
                element,
              },
              { root: true }
            );
          } else if (change.type === "removed") {
            commit(
              "dataLists/unsetArrayItem",
              {
                id: change.doc.id,
                list: "MBS_Beneficios",
              },
              { root: true }
            );
          }
        });
      });
    },
    async listenerMBSMembresias({ commit, rootGetters }, { batchSize = 100, batchTimeout = 500 } = {}) {
      const firestore = rootGetters.getFirebaseApp.firestore;
      let last = await Vue.prototype.$dbHandler.getLastRecord(
        "MBS_Membresias",
        "Upat"
      );
      let batchItems = [];
      let batchIdsToRemove = [];
      let batchTimer;
      const listName = "MBS_Membresias";
      const processBatches = () => {
        if (batchItems.length > 0) {
          commit(
            "dataLists/setArrayItems",
            {
              list: listName,
              elements: batchItems.map(item => ({ id: item.id, ...item.element }))
            },
            { root: true }
          );
          batchItems = [];
        }

        if (batchIdsToRemove.length > 0) {
          commit(
            "dataLists/unsetArrayItems",
            {
              list: listName,
              ids: batchIdsToRemove
            },
            { root: true }
          );
          batchIdsToRemove = [];
        }
      };
      const scheduleProcess = () => {
        clearTimeout(batchTimer);
        batchTimer = setTimeout(processBatches, batchTimeout);
      };

      const collection = firestore.collection("MBS_Membresias");
      const query = firestore.query(
        collection,
        firestore.where("Upat", ">=", last ? last.value.Upat : 0),
        firestore.where("Tenant", "==", rootGetters.getFirebaseApp.tenant)
      );
      const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added" || change.type === "modified") {
            batchItems.push({ id: change.doc.id, element });
            if (batchItems.length >= batchSize) {
              processBatches();
            }
          } else if (change.type === "removed") {
            batchIdsToRemove.push(change.doc.id);
          }
        });
        scheduleProcess();
      });
    },
  },
};
